/* eslint-disable no-lonely-if */
import * as marietta from '../../..';
import { Point } from '../../../core';

export default class Wall {
  parentObj: marietta.webcad.item.MonicaObject;

  parentObjInfo: marietta.webcad.collection.ItemInfoCollection;

  viewObj: SVGElement;

  private viewObjForMouse: SVGElement;

  rotation: number;

  x: number;

  y: number;

  /** 壁タイプ* */
  _wallType: number;

  get wallType(): number { return this._wallType; }

  set wallType(value: number) {
    this._wallType = value;
    this._startDot.wall_type = this._wallType;
    this.drawWall();
  }

  /** 角度* */
  _angle: number;

  get angle(): number { return this._angle; }

  set angle(value: number) {
    this._angle = value;
    this.rotation = this._angle;
  }

  /** 始点* */
  _startDot: marietta.webcad.collection.PointCollection;

  get startDot(): marietta.webcad.collection.PointCollection { return this._startDot; }

  set startDot(value: marietta.webcad.collection.PointCollection) {
    this._startDot = value;
    // 角度を計算して代入
    if (this.endDot) {
      this.angle = marietta.webcad.util.WebCADUtil.getAngleBetweenPoints(this.startDot.point, this.endDot.point);
      this.drawWall();
    }
    this.x = this.startDot.x;
    this.y = this.startDot.y;
  }

  get startDotGlobalPoint(): marietta.core.Point {
    if (!this.parentObj.spt) return;

    let p1: marietta.core.Point = new marietta.core.Point(this.startDot.point.x, this.startDot.point.y);
    // 親が階段で反転している場合は、予めXを操作しておく
    if (this.parentObj.itemInfo.lr) {
      p1 = new marietta.core.Point(-this.startDot.point.x, this.startDot.point.y);
    }
    const r: number = ((this.parentObj.spt.rotation % 360) / 180) * Math.PI;
    const xx: number = p1.x * Math.cos(r) - p1.y * Math.sin(r);
    const yy: number = p1.x * Math.sin(r) + p1.y * Math.cos(r);
    p1.x = xx;
    p1.y = yy;
    const retPoint: any = this.parentObj.spt.localToGlobal(new Point(p1.x, p1.y));
    return new marietta.core.Point(retPoint.x, retPoint.y);
  }

  /** 終点* */
  _endDot: marietta.webcad.collection.PointCollection;

  get endDot(): marietta.webcad.collection.PointCollection { return this._endDot; }

  set endDot(value: marietta.webcad.collection.PointCollection) {
    this._endDot = value;
    // 角度を計算して代入
    if (this._endDot) {
      this.angle = marietta.webcad.util.WebCADUtil.getAngleBetweenPoints(this.startDot.point, this.endDot.point);
      this.drawWall();
    }
  }

  get endDotGlobalPoint(): marietta.core.Point {
    if (!this.parentObj.spt) return;

    let p1: marietta.core.Point = new marietta.core.Point(this.endDot.point.x, this.endDot.point.y);
    // 親が階段で反転している場合は、予めXを操作しておく
    if (this.parentObj.itemInfo.lr) {
      p1 = new marietta.core.Point(-this.endDot.point.x, this.endDot.point.y);
    }

    const r: number = ((this.parentObj.spt.rotation % 360) / 180) * Math.PI;
    const xx: number = p1.x * Math.cos(r) - p1.y * Math.sin(r);
    const yy: number = p1.x * Math.sin(r) + p1.y * Math.cos(r);
    p1.x = xx;
    p1.y = yy;
    const retPoint: any = this.parentObj.spt.localToGlobal(new Point(p1.x, p1.y));
    return new marietta.core.Point(retPoint.x, retPoint.y);
  }

  get globalStartDot(){
    return new marietta.core.Point(this.parentObj.itemInfo.x + this.startDot.x, this.parentObj.itemInfo.y + this.startDot.y);
  }

  get globalEndDot(){
    return new marietta.core.Point(this.parentObj.itemInfo.x + this.endDot.x, this.parentObj.itemInfo.y + this.endDot.y);
  }

  /** index* */
  _index: number;

  get index(): number { return this._index; }

  set index(value: number) { this._index = value; }

  /**
   * コンストラクタ
   */
  constructor(__index: number, tarView, __startDot: marietta.webcad.collection.PointCollection, __endDot: marietta.webcad.collection.PointCollection, linecap: string = '') {
    this.index = __index;
    this.startDot = __startDot;
    this.endDot = __endDot;
    const colorInfo = marietta.webcad.WebCADGlobal.getColorForWallType(this.wallType);
    // ベースとなるidの抽出
    const idBase = tarView.id.replace(/wallGroup/g, '');

    // 親エレメント作成
    const parentElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    parentElement.setAttribute('id', `${idBase}_wall${__index + 1}`);

    // 実際のイメージ
    this.viewObj = this.createWallStroke(idBase, linecap);
    parentElement.appendChild(this.viewObj);

    // マウスイベント用透明壁
    this.viewObjForMouse = this.createWallDummyForMouse(idBase, linecap);
    parentElement.appendChild(this.viewObjForMouse);
    this.viewObjForMouse.addEventListener('mousedown', this.onMouseDownMe);

    tarView.appendChild(parentElement);
  }

  /**
   * 実際のイメージ
   * @param idBase
   * @param linecap
   * @returns
   */
  private createWallStroke(idBase: string, linecap: string = ''): SVGPathElement {
    const colorInfo = marietta.webcad.WebCADGlobal.getColorForWallType(this.wallType);
    const viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    viewObj.setAttribute('id', `${idBase}wallStroke`);
    viewObj.setAttribute('fill', 'none');
    viewObj.setAttribute('stroke', colorInfo.color);
    viewObj.setAttribute('opacity', String(colorInfo.alpha));
    viewObj.setAttribute('stroke-width', String(marietta.webcad.WebCADGlobal.WALL_WIDTH));
    if (linecap !== '') {
      viewObj.setAttribute('stroke-linecap', linecap);
    }
    const point1: marietta.core.Point = new marietta.core.Point(this._startDot.x, this._startDot.y);
    const point2: marietta.core.Point = new marietta.core.Point(this._endDot.x, this._endDot.y);
    viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(point1, point2));
    return viewObj;
  }

  /**
   * ダミーマウスイベント用透明壁
   * @param idBase
   * @param linecap
   * @returns
   */
  private createWallDummyForMouse(idBase: string, linecap: string = ''): SVGPathElement {
    const viewObjForMouse = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    viewObjForMouse.setAttribute('id', `${idBase}wallDumyForMouse`);
    viewObjForMouse.setAttribute('fill', 'none');
    viewObjForMouse.setAttribute('stroke', '#FFFFFF');
    viewObjForMouse.setAttribute('opacity', '0');
    if (linecap !== '') {
      viewObjForMouse.setAttribute('stroke-linecap', linecap);
    }
    viewObjForMouse.setAttribute('stroke-width', String(marietta.webcad.WebCADGlobal.WALL_WIDTH));
    const point1: marietta.core.Point = new marietta.core.Point(this._startDot.x, this._startDot.y);
    const point2: marietta.core.Point = new marietta.core.Point(this._endDot.x, this._endDot.y);
    viewObjForMouse.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(point1, point2));
    return viewObjForMouse;
  }


  /**
   * 壁の描画
   */
  drawWall() {
    if (!this.viewObj) return;
    const colorInfo = marietta.webcad.WebCADGlobal.getColorForWallType(this.wallType);
    this.viewObj.setAttribute('fill', 'none');
    this.viewObj.setAttribute('stroke', colorInfo.color);
    this.viewObj.setAttribute('opacity', String(colorInfo.alpha));
    this.viewObj.setAttribute('stroke-width', String(marietta.webcad.WebCADGlobal.WALL_WIDTH));
  }

  /**
   * ハイライト
   * */
  highlight(value: boolean) {
    if (value) {
      this.viewObj.setAttribute('stroke', '#ED7A2D');
      this.viewObj.setAttribute('opacity', '1');
    } else {
      const colorInfo = marietta.webcad.WebCADGlobal.getColorForWallType(this.wallType);
      this.viewObj.setAttribute('stroke', colorInfo.color);
      this.viewObj.setAttribute('opacity', String(colorInfo.alpha));
    }
  }

  /**
   * 壁の追加
   */
  addWall() {
    // 全面壁に変更
    this.wallType = 1;
    this.parentObj.itemInfo.dotList[this.index].wall_type = this.wallType;

    // 全体の更新
    this.parentObj.reCreateImage();

    marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
  }

  /**
  * 壁の削除
  */
  removeWall(update:boolean = true) {
    // 開口に変更
    this.wallType = 0;
    this.parentObj.itemInfo.dotList[this.index].wall_type = this.wallType;

    // 全体の更新
    this.parentObj.reCreateImage();
    if (update) marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
  }

  /**
   * 一致する壁を取得する(同じ頂点)
   * @returns
   */
  getMatchingWall() {
    // 現在の階のスナップ準備をする
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
    const wallList = marietta.webcad.WebCADGlobal.webcad2Dmanager.wallList;
    const closestWalls = [];
    for (let i: number = 0; i < wallList.length; i += 1) {
      if (wallList[i].startDot.guid !== this.startDot.guid && marietta.webcad.util.WebCADUtil.isSimilarLine({ p1: wallList[i].globalStartDot, p2: wallList[i].globalEndDot }, { p1: this.globalStartDot, p2: this.globalEndDot })) {
        closestWalls.push(wallList[i]);
      }
    }
    if (closestWalls.length < 1) return null;
    return closestWalls;
  }

  /**
   * 指定された要素が自分のマウスイベント用透明壁かどうか
   * @param target イベントのターゲット要素
   * @returns
   */
  public isMouseTargetElement(target: EventTarget): boolean {
    return this.viewObjForMouse === target;
  }

  /**
   * マウスダウン時の処理
   * @param e
   * @returns
   */
  onMouseDownMe = (e: MouseEvent) => {
    // タブレット等の複数選択モード中は壁を選択できないようにする（単一選択時は従来どおり選択可）
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isTapMultiSelectMode) return;

    if (!marietta.webcad.WebCADGlobal.layerGroup.itemEnabled) {
      marietta.webcad.WebCADGlobal.itemManager.currentWall = null;
      return;
    }

    e.stopPropagation();
    // ドラッグの開始
    e.preventDefault();
    const matchingWalls = this.getMatchingWall();

    // 屋根は複数選択しない
    if ((e.shiftKey || e.ctrlKey)) {
      const prevItem: marietta.webcad.item.parts.Wall = marietta.webcad.WebCADGlobal.itemManager.currentWall;
      if ((!marietta.webcad.WebCADGlobal.itemManager.currentWall) && (!marietta.webcad.WebCADGlobal.itemManager.currentWallGroup)) {
        if (matchingWalls && matchingWalls.length > 0) {
          marietta.webcad.WebCADGlobal.itemManager.addWalls([...matchingWalls, this]);
        } else {
          marietta.webcad.WebCADGlobal.itemManager.currentWall = this;
        }
      } else {
        if (matchingWalls && matchingWalls.length > 0) {
          const newList = [...matchingWalls, this];
          if (prevItem) newList.push(prevItem);
          newList.forEach((w: Wall) => {
            if (marietta.webcad.WebCADGlobal.itemManager.currentWallGroup && !marietta.webcad.WebCADGlobal.itemManager.currentWallGroup.myItemList.find((item) => item.startDot.guid === w.startDot.guid)) {
              marietta.webcad.WebCADGlobal.itemManager.addWallToGroupObject(w);
            } else if (marietta.webcad.WebCADGlobal.itemManager.currentWallGroup == null) {
              marietta.webcad.WebCADGlobal.itemManager.addWallToGroupObject(w);
            }
          });
        } else {
          marietta.webcad.WebCADGlobal.itemManager.addWallToGroupObject(this, prevItem);
        }
      }
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null) {
        marietta.webcad.WebCADGlobal.itemManager.addItemToGroupObject(marietta.webcad.WebCADGlobal.itemManager.currentItem);
      }
      return;
    }
    if ((marietta.webcad.WebCADGlobal.itemManager.currentItem != null || marietta.webcad.WebCADGlobal.itemManager.currentWallGroup != null || marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null)) {
      marietta.webcad.WebCADGlobal.itemManager.unselectAllCurrents();
    }
    if (matchingWalls && matchingWalls.length > 0) {
      marietta.webcad.WebCADGlobal.itemManager.addWalls([...matchingWalls, this]);
    } else {
      marietta.webcad.WebCADGlobal.itemManager.currentWall = this;
    }
  }
}
